var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-container"},[_c('div'),(_vm.shouldEnableConversations)?_c('div',[(_vm.showChat && _vm.userID)?_c('conversations-container-v2',{attrs:{"currentUserId":_vm.userID,"theme":_vm.theme}}):_vm._e()],1):_c('div',[_c('span',[_vm._v("You do not have this feature enabled yet. Please contact teamio support.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }